/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_TitleInputs */

const en_lessons_title = /** @type {(inputs: Lessons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessons`)
};

const he_lessons_title = /** @type {(inputs: Lessons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורים`)
};

/**
* | output |
* | --- |
* | "Lessons" |
*
* @param {Lessons_TitleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_title = /** @type {((inputs?: Lessons_TitleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_TitleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_title(inputs)
	return he_lessons_title(inputs)
});